import { Entry } from 'contentful'
import { getContentfulAsset } from '~/libs/contentful/helpers'
import { TypeAdvantagesBlockSkeleton } from '~/types/contentful'

type AdvantagesProps = {
  section: Entry<TypeAdvantagesBlockSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const Advantages = ({ section }: AdvantagesProps) => {
  const data = section.fields

  const firstIcon = getContentfulAsset(data.firstIcon)
  const secondIcon = getContentfulAsset(data.secondIcon)
  const thirdIcon = getContentfulAsset(data.thirdIcon)
  const fourthIcon = getContentfulAsset(data.fourthIcon)

  const advantages = [
    {
      title: data.firstCounter,
      description: data.firstDescription,
      backgroundImage: firstIcon ? firstIcon?.fields?.file?.url : '',
    },
    {
      title: data.secondCounter,
      description: data.secondDescription,
      backgroundImage: secondIcon ? secondIcon?.fields?.file?.url : '',
    },
    {
      title: data.thirdCounter,
      description: data.thirdDescription,
      backgroundImage: thirdIcon ? thirdIcon?.fields?.file?.url : '',
    },
    {
      title: data.fourthCounter,
      description: data.fourthDescription,
      backgroundImage: fourthIcon ? fourthIcon?.fields?.file?.url : '',
    },
  ]

  return (
    <>
      <section
        className="my-25 -mx-8 max-xl:px-11 max-lg:my-15 max-lg:-mx-6 max-md:my-0 max-md:-mx-4 max-md:pt-11 max-md:px-4 max-md:pb-17"
        data-block-id={data.blockId}
      >
        <div className="flex max-md:flex-col justify-center max-xl:justify-center max-md:gap-5 mx-auto lg:w-8/12 w-10/12">
          {advantages.map((advantage, idx) => (
            <div
              key={idx}
              className="flex flex-col max-md:gap-6 flex-1 max-md:text-start max-md:flex-row max-md:flex-start gap-2"
            >
              <div className="flex justify-center items-center h-22 w-22 max-md:h-16 max-md:w-16 self-center">
                <img
                  src={advantage.backgroundImage}
                  alt=""
                  loading="lazy"
                  className="max-w-full max-h-full w-auto h-auto object-contain"
                />
              </div>
              <div className="flex flex-col lg:justify-center justify-start text-start lg:text-center">
                <p className="text-l max-md:m-0 max-lg:mb-2 mt-2 m-0">{advantage.title}</p>
                <p className="text-s text-neutral-50 mt-1">{advantage.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}
